/**
 * Event Bus for handling domain events and coordination
 */
export type EventCallback<T = any> = (data: T) => void | Promise<void>;

export class EventBus {
  private listeners: Map<string, Set<EventCallback>> = new Map();

  on<T = any>(event: string, callback: EventCallback<T>): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);
    return () => this.off(event, callback);
  }

  off<T = any>(event: string, callback: EventCallback<T>): void {
    if (this.listeners.has(event)) {
      this.listeners.get(event)!.delete(callback);
    }
  }

  async emit<T = any>(event: string, data?: T): Promise<void> {
    if (this.listeners.has(event)) {
      const callbacks = Array.from(this.listeners.get(event)!);
      await Promise.all(callbacks.map(cb => {
        try {
          return Promise.resolve(cb(data));
        } catch (e) {
          console.error(`[EventBus] Error in listener for event "${event}":`, e);
          return Promise.resolve();
        }
      }));
    }
  }

  clear(): void {
    this.listeners.clear();
  }
}


